import React from "react";
import { Box, Button, Icon, TabPanel } from "@chakra-ui/react";
import TableOrder from "components/Tables/TableOrder";
import IntegracionBoxCrudContex from "context/IntegracionBoxCrudContex";
import SearchByItem from "components/Search/SearchByItem";
import useServerItemSearch from "hooks/useServerItemSearch";
import {
  arrayMatteriaEdit,
  arrayMatteriaNotEdit,
  arrayMatteriaNotEditCorrected,
  items,
  theadDesperdicios,
  theadElaborated,
  theadElaboratedNotEdit,
  theadMateria,
  theadMateriaIsCommerce,
  theadMateriaNotEditable,
  theadMateriaNotEditableIsCommerce,
  theadOther,
  theadOtherEdit,
} from "pages/IntegrationBox/Arrays/ArrayTitles";
import { TotalsCalculated } from "pages/IntegrationBox/BoxCalc/TotalsCalculated";
import TBodyGarbage from "pages/IntegrationBox/Table/TbodyDesperdicio";
import TbodyGarbageUnit from "pages/IntegrationBox/Table/TbodyGarbageUnit";
import TbodyElaborateProduct from "pages/IntegrationBox/Table/TbodyElaborateProduct";
import TbodyOtherCosts from "pages/IntegrationBox/Table/TbodyOtherCosts";
import TbodyRawMaterial from "pages/IntegrationBox/Table/TbodyRawMaterial";
import TbodySupplyUnit from "pages/IntegrationBox/Table/TbodySupplyUnit";
import TbodyUndCertificated from "pages/IntegrationBox/Table/TbodyUnitCertificated";
import { TabsCreateOrder } from "pages/ProductionOrder/TabsCreate/TabsCreateOrder";
import { useContext, useEffect, useState, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { BoxCalc } from "pages/IntegrationBox/BoxCalc/BoxCalc";
import ButtonsTable from "../ViewTableBox/ButtonsTable";

import { useSelector } from "react-redux";
import environment from "constants/apiConst";
import SpinnerComponent from "components/Spinner/SpinnerComponent";
import "./index.css";
import { useInfiniteQuery, useQuery, useQueryClient } from "@tanstack/react-query";
import { useGlobalContext } from "context/GlobalContext";
import queryString from "query-string";
import queryEnv from "constants/queryConst";
import InfiniteScroll from "react-infinite-scroll-component";
import InputSelect from "components/InputSelect/InputSelect";
import { FaCheck, FaTimes } from "react-icons/fa";
import { Fab } from "react-tiny-fab";
import "react-tiny-fab/dist/styles.css";
import { RiListSettingsLine } from "react-icons/ri";
import Pagination from "components/Pagination/Pagination";

const CustomButton = ({ isActive, onClick, children }) => {
  return (
    <Button
      leftIcon={
        <Icon
          as={isActive ? FaCheck : FaTimes}
          color={isActive ? "green.400" : "red.400"}
        />
      }
      onClick={onClick}
      bg={isActive ? "blue.600" : "blue.400"}
      _hover={{ bg: isActive ? "blue.700" : "blue.500" }}
      color="white"
      width="180px"
      height="30px"
      marginBottom="4px"
      transition="all 0.3s ease"
    >
      {children}
    </Button>
  );
};

const OptionPanelTabs = () => {
  const location = useLocation();
  const [positionView, setPositionView] = useState(0);
  const [cambio, setCambio] = useState(0);
  const { pathname } = location;
  const { is_qualified_user } = useSelector((state) => state.auth.dataUser);
  const { id = null, idCorrected = null } = queryString.parse(location.search);
  const { ciModuleDynamic } = useSelector((state) => state?.form) || {};

  const { requestData, isOpen, setIsOpen } = useGlobalContext();

  const queryClient = useQueryClient();
  const foundMutation = queryClient.getQueryData([queryEnv?.INTEGRATION_BOX]);
  const [supplyFilter, setSupplyFilter] = useState(null);
  const [orderBy, setOrderBy] = useState({ value: "ASC", label: "Ascendente" });

  // Estado para toggle de scroll infinito (por defecto true - modo scroll infinito)
  const [listMode, setListMode] = useState(true);
  const [ciProductsPage, setCiProductsPage] = useState(1);
  const [ciSuppliesPage, setCiSuppliesPage] = useState(1);
  const [ciOtherCostPage, setCiOtherCostPage] = useState(1);
  const [ciGarbagePage, setCiGarbagePage] = useState(1);

  const switchLoadingItem = () => {
    setListMode((prev) => !prev);
    // Resetear páginas al cambiar de modo
    setCiProductsPage(1);
    setCiSuppliesPage(1);
    setCiOtherCostPage(1);
    setCiGarbagePage(1);
  };

  // Refs para los contenedores de scroll infinito
  const productsScrollRef = useRef(null);
  const suppliesScrollRef = useRef(null);
  const otherCostsScrollRef = useRef(null);
  const garbageScrollRef = useRef(null);

  const {
    currentPage2,
    setCurrentPage2,
  } = useContext(IntegracionBoxCrudContex);

  const handleCambio = (index) => {
    setCambio(index);
    setPositionView(index);
    localStorage.setItem("indexTabs", JSON.stringify(index));
  };

  const handleOpenDatosInsumo = () => {
    setIsOpen((prev) => !prev);
  };

  const indexTabs = JSON.parse(localStorage.getItem("indexTabs"));

  useEffect(() => {
    if (indexTabs) {
      setPositionView(indexTabs);
    }
  }, [indexTabs]);

  /**
   * Represents a book.
   * @constructor
   * @param {string} is_qualified_user - is on auth.dataUser and 1 is true and 0 is false.
   */

  const THead = {
    "/ShowIntegrationBox": () => {
      const dispatchThead = {
        0: theadMateriaNotEditableIsCommerce,
        1: theadMateriaNotEditable,
      };
      return dispatchThead[is_qualified_user];
    },
    Default: () => {
      const defaultThead = {
        0: theadMateriaIsCommerce,
        1: theadMateria,
      };
      return defaultThead[is_qualified_user];
    },
  };

  // Función para obtener página de productos (usando useCallback para evitar problemas de closure)
  const fetchProductsPage = useCallback(async ({ pageParam = 1 }) => {
    if (!(idCorrected || id)) return { items: [], nextCursor: null };

    // Usar 10000 items por página en modo scroll infinito
    const itemsPerPage = 10000;

    const res = await requestData({
      Endpoint: idCorrected
        ? environment.GET_PRODUCTS_CI_CORRECTED
        : environment.GET_PRODUCTS_CI,
      resourceIdentifier: idCorrected ? idCorrected : id,
      pageParam: pageParam,
      data: {
        orderBy: orderBy.value,
        length: itemsPerPage,
      },
      method: "POST",
    });

    if (res?.data?.status?.code === 200) {
      const lastPage = res?.data?.status?.data?.last_page || 1;
      const nextCursor = pageParam >= lastPage ? null : pageParam + 1;
      return {
        items: res?.data?.status?.data?.data || [],
        nextCursor: nextCursor,
        totals: {
          total_product_net_weight: res?.data?.status?.data?.total_product_net_weight,
          total_product_fob: res?.data?.status?.data?.total_product_fob,
          totalProdQuantity: res?.data?.status?.data?.totalProdQuantity,
        },
      };
    }
    return { items: [], nextCursor: null };
  }, [idCorrected, id, orderBy.value, requestData]);

  // Función para obtener página de insumos
  async function fetchSuppliesPage({ pageParam = 1 }) {
    if (!(idCorrected || id)) return { items: [], nextCursor: null };

    // Usar 10000 items por página en modo scroll infinito, 5 en modo normal
    const itemsPerPage = listMode ? 10000 : 5;

    const res = await requestData({
      pageParam: pageParam,
      data: {
        orderBy: orderBy.value,
        length: itemsPerPage,
      },
      Endpoint: idCorrected
        ? environment.GET_SUPPLYS_CI_CORRECTED
        : environment.GET_SUPPLYS_CI,
      resourceIdentifier: `${idCorrected ? idCorrected : id}${
        supplyFilter ? `/${supplyFilter}` : ""
      }`,
      method: "POST",
    });

    if (res?.data?.status?.code === 200) {
      const lastPage = res?.data?.status?.data?.last_page || 1;
      const nextCursor = pageParam >= lastPage ? null : pageParam + 1;
      return {
        items: res?.data?.status?.data?.data || [],
        nextCursor: nextCursor,
        totals: {
          total_supply_net_weight_new: res?.data?.status?.data?.total_supply_net_weight_new,
          total_supply_fob_new: res?.data?.status?.data?.total_supply_fob_new,
          totalSupplies: res?.data?.status?.data?.totalSupplies,
        },
      };
    }
    return { items: [], nextCursor: null };
  }

  // Función para obtener página de otros costos
  async function fetchOtherCostsPage({ pageParam = 1 }) {
    if (!(idCorrected || id)) return { items: [], nextCursor: null };

    // Usar 10000 items por página en modo scroll infinito, 5 en modo normal
    const itemsPerPage = listMode ? 10000 : 5;

    const res = await requestData({
      Endpoint: idCorrected
        ? environment.GET_OTHER_COST_CI_CORRECTED
        : environment.GET_OTHER_COST_CI,
      resourceIdentifier: idCorrected ? idCorrected : id,
      pageParam: pageParam,
      data: {
        orderBy: orderBy.value,
        length: itemsPerPage,
      },
      method: "POST",
    });

    if (res?.data?.status?.code === 200) {
      const lastPage = res?.data?.status?.data?.last_page || 1;
      const nextCursor = pageParam >= lastPage ? null : pageParam + 1;
      return {
        items: res?.data?.status?.data?.data || [],
        nextCursor: nextCursor,
        totals: {
          totalOtherNetWeight: res?.data?.status?.data?.totalOtherNetWeight,
          totalOtherFobValue: res?.data?.status?.data?.totalOtherFobValue,
          totalValueUnit: res?.data?.status?.data?.totalValueUnit,
        },
      };
    }
    return { items: [], nextCursor: null };
  }

  // Función para obtener página de desperdicios
  async function fetchGarbagePage({ pageParam = 1 }) {
    if (!(idCorrected || id)) return { items: [], nextCursor: null };

    // Usar 10000 items por página en modo scroll infinito, 5 en modo normal
    const itemsPerPage = listMode ? 10000 : 5;

    const res = await requestData({
      Endpoint: idCorrected
        ? environment.GET_GARBAGES_CI_CORRECTED
        : environment.GET_GARBAGES_CI,
      resourceIdentifier: idCorrected ? idCorrected : id,
      pageParam: pageParam,
      data: {
        orderBy: orderBy.value,
        length: itemsPerPage,
      },
      method: "POST",
    });

    if (res?.data?.status?.code === 200) {
      const lastPage = res?.data?.status?.data?.last_page || 1;
      const nextCursor = pageParam >= lastPage ? null : pageParam + 1;
      return {
        items: res?.data?.status?.data?.data || [],
        nextCursor: nextCursor,
        totals: {
          totalGarbageQuantity: res?.data?.status?.data?.unit_array_value_garbage,
        },
      };
    }
    return { items: [], nextCursor: null };
  }

  // Queries para modo normal (paginación) - solo cuando listMode es false
  const { data: ciProductsNormal, isLoading: isLoadingCiProductsNormal } = useQuery({
    queryKey: [queryEnv?.PRODUCTS_CI, ciProductsPage, idCorrected, id, orderBy?.value, "normal"],
    queryFn: () =>
      (idCorrected || id) &&
      requestData({
        Endpoint: idCorrected
          ? environment.GET_PRODUCTS_CI_CORRECTED
          : environment.GET_PRODUCTS_CI,
        resourceIdentifier: idCorrected ? idCorrected : id,
        pageParam: ciProductsPage,
        data: {
          orderBy: orderBy.value,
          length: 5,
        },
        method: "POST",
      }),
    enabled: !!(idCorrected || id) && !listMode,
    staleTime: 5 * 60 * 1000, // 5 minutos - los datos se consideran frescos por 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos - los datos se mantienen en caché por 10 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  // Infinite queries para modo scroll infinito - solo cuando listMode es true
  const {
    data: ciProducts,
    isLoading: isLoadingCiProducts,
    isFetchingNextPage: isFetchingNextProductsPage,
    fetchNextPage: fetchNextProductsPage,
    hasNextPage: hasNextProductsPage,
  } = useInfiniteQuery({
    queryKey: [queryEnv?.PRODUCTS_CI, idCorrected, id, orderBy?.value, "infinite"],
    queryFn: fetchProductsPage,
    getNextPageParam: (lastPage) => lastPage?.nextCursor,
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000, // 5 minutos - los datos se consideran frescos por 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos - los datos se mantienen en caché por 10 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!(idCorrected || id) && listMode,
    initialPageParam: 1,
  });

  // Queries normales para las otras pestañas
  const { data: ciSuppliesNormal, isLoading: isLoadingCiSuppliesNormal } = useQuery({
    queryKey: [queryEnv?.SUPPLIES_CI, ciSuppliesPage, idCorrected, id, orderBy?.value, supplyFilter, "normal"],
    queryFn: () =>
      (idCorrected || id) &&
      requestData({
        pageParam: ciSuppliesPage,
        data: {
          orderBy: orderBy.value,
          length: 5,
        },
        Endpoint: idCorrected
          ? environment.GET_SUPPLYS_CI_CORRECTED
          : environment.GET_SUPPLYS_CI,
        resourceIdentifier: `${idCorrected ? idCorrected : id}${
          supplyFilter ? `/${supplyFilter}` : ""
        }`,
        method: "POST",
      }),
    enabled: !!(idCorrected || id) && !listMode,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const { data: ciOtherCostNormal, isLoading: isLoadingCiOtherCostNormal } = useQuery({
    queryKey: [queryEnv?.OTHER_COST_CI, ciOtherCostPage, idCorrected, id, orderBy?.value, "normal"],
    queryFn: () =>
      (idCorrected || id) &&
      requestData({
        Endpoint: idCorrected
          ? environment.GET_OTHER_COST_CI_CORRECTED
          : environment.GET_OTHER_COST_CI,
        resourceIdentifier: idCorrected ? idCorrected : id,
        pageParam: ciOtherCostPage,
        data: {
          orderBy: orderBy.value,
          length: 5,
        },
        method: "POST",
      }),
    enabled: !!(idCorrected || id) && !listMode,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const { data: ciGarbageNormal, isLoading: isLoadingCiGarbageNormal } = useQuery({
    queryKey: [queryEnv?.GARBAGE_CI, ciGarbagePage, idCorrected, id, orderBy?.value, "normal"],
    queryFn: () =>
      (idCorrected || id) &&
      requestData({
        Endpoint: idCorrected
          ? environment.GET_GARBAGES_CI_CORRECTED
          : environment.GET_GARBAGES_CI,
        resourceIdentifier: idCorrected ? idCorrected : id,
        pageParam: ciGarbagePage,
        data: {
          orderBy: orderBy.value,
          length: 5,
        },
        method: "POST",
      }),
    enabled: !!(idCorrected || id) && !listMode,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  // Infinite queries para modo scroll infinito
  const {
    data: ciSupplies,
    isLoading: isLoadingCiSupplies,
    fetchNextPage: fetchNextSuppliesPage,
    hasNextPage: hasNextSuppliesPage,
  } = useInfiniteQuery({
    queryKey: [
      queryEnv?.SUPPLIES_CI,
      idCorrected,
      id,
      orderBy?.value,
      supplyFilter,
      "infinite",
    ],
    queryFn: fetchSuppliesPage,
    getNextPageParam: (lastPage) => lastPage?.nextCursor,
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!(idCorrected || id) && listMode,
  });

  const {
    data: ciOtherCost,
    isLoading: isLoadingCiOtherCost,
    fetchNextPage: fetchNextOtherCostsPage,
    hasNextPage: hasNextOtherCostsPage,
  } = useInfiniteQuery({
    queryKey: [queryEnv?.OTHER_COST_CI, idCorrected, id, orderBy?.value, "infinite"],
    queryFn: fetchOtherCostsPage,
    getNextPageParam: (lastPage) => lastPage?.nextCursor,
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!(idCorrected || id) && listMode,
  });

  const {
    data: ciGarbage,
    isLoading: isLoadingCiGarbage,
    fetchNextPage: fetchNextGarbagePage,
    hasNextPage: hasNextGarbagePage,
  } = useInfiniteQuery({
    queryKey: [queryEnv?.GARBAGE_CI, idCorrected, id, orderBy?.value, "infinite"],
    queryFn: fetchGarbagePage,
    getNextPageParam: (lastPage) => lastPage?.nextCursor,
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!(idCorrected || id) && listMode,
  });

  const tabsCI = [...items];

  if (
    ciModuleDynamic?.nameModul === "Asociación de Materias primas e Insumos"
  ) {
    tabsCI.splice(0, 1, "Descripción de mercancía");
  }

  // Extraer datos según el modo (normal o infinite scroll)
  const getProductsData = () => {
    if (listMode) {
      return ciProducts?.pages
        ? ciProducts.pages.flatMap((page) => page?.items || []).sort((a, b) => {
            return (a?.item || 0) - (b?.item || 0);
          })
        : [];
    } else {
      return ciProductsNormal?.data?.status?.code === 200 && !isLoadingCiProductsNormal
        ? (ciProductsNormal?.data?.status?.data?.data || []).sort((a, b) => {
            return (a?.item || 0) - (b?.item || 0);
          })
        : [];
    }
  };

  const getSuppliesData = () => {
    if (listMode) {
      return ciSupplies?.pages
        ? ciSupplies.pages.flatMap((page) => page?.items || []).sort((a, b) => {
            return (a?.item || 0) - (b?.item || 0);
          })
        : [];
    } else {
      return ciSuppliesNormal?.data?.status?.code === 200 && !isLoadingCiSuppliesNormal
        ? (ciSuppliesNormal?.data?.status?.data?.data || []).sort((a, b) => {
            return (a?.item || 0) - (b?.item || 0);
          })
        : [];
    }
  };

  const getOtherCostsData = () => {
    if (listMode) {
      return ciOtherCost?.pages
        ? ciOtherCost.pages.flatMap((page) => page?.items || []).sort((a, b) => {
            return (a?.item || 0) - (b?.item || 0);
          })
        : [];
    } else {
      return ciOtherCostNormal?.data?.status?.code === 200 && !isLoadingCiOtherCostNormal
        ? (ciOtherCostNormal?.data?.status?.data?.data || []).sort((a, b) => {
            return (a?.item || 0) - (b?.item || 0);
          })
        : [];
    }
  };

  const getGarbageData = () => {
    if (listMode) {
      return ciGarbage?.pages
        ? ciGarbage.pages.flatMap((page) => page?.items || []).sort((a, b) => {
            return (a?.item || 0) - (b?.item || 0);
          })
        : [];
    } else {
      return ciGarbageNormal?.data?.status?.code === 200 && !isLoadingCiGarbageNormal
        ? (ciGarbageNormal?.data?.status?.data?.data || []).sort((a, b) => {
            return (a?.item || 0) - (b?.item || 0);
          })
        : [];
    }
  };

  const productsData = getProductsData();
  console.log("productsData: ", productsData);
  const suppliesData = getSuppliesData();
  const otherCostsData = getOtherCostsData();
  const garbageData = getGarbageData();

  // Extraer totales según el modo
  const getProductsTotals = () => {
    if (listMode) {
      return ciProducts?.pages?.[ciProducts.pages.length - 1]?.totals || {};
    } else {
      return ciProductsNormal?.data?.status?.code === 200
        ? {
            total_product_net_weight: ciProductsNormal?.data?.status?.data?.total_product_net_weight,
            total_product_fob: ciProductsNormal?.data?.status?.data?.total_product_fob,
            totalProdQuantity: ciProductsNormal?.data?.status?.data?.totalProdQuantity,
          }
        : {};
    }
  };

  const getSuppliesTotals = () => {
    if (listMode) {
      return ciSupplies?.pages?.[ciSupplies.pages.length - 1]?.totals || {};
    } else {
      return ciSuppliesNormal?.data?.status?.code === 200
        ? {
            total_supply_net_weight_new: ciSuppliesNormal?.data?.status?.data?.total_supply_net_weight_new,
            total_supply_fob_new: ciSuppliesNormal?.data?.status?.data?.total_supply_fob_new,
            totalSupplies: ciSuppliesNormal?.data?.status?.data?.totalSupplies,
          }
        : {};
    }
  };

  const getOtherCostsTotals = () => {
    if (listMode) {
      return ciOtherCost?.pages?.[ciOtherCost.pages.length - 1]?.totals || {};
    } else {
      return ciOtherCostNormal?.data?.status?.code === 200
        ? {
            totalOtherNetWeight: ciOtherCostNormal?.data?.status?.data?.totalOtherNetWeight,
            totalOtherFobValue: ciOtherCostNormal?.data?.status?.data?.totalOtherFobValue,
            totalValueUnit: ciOtherCostNormal?.data?.status?.data?.totalValueUnit,
          }
        : {};
    }
  };

  // Extraer totales según el modo
  const getGarbageTotals = () => {
    if (listMode) {
      const lastPage = ciGarbage?.pages?.[ciGarbage.pages.length - 1];
      const unitTotals = lastPage?.totals?.totalGarbageQuantity || [];
      // Sumar peso en kilos de los items visibles (garbageData ya está ordenado/flattened)
      const totalNetWeight = Array.isArray(garbageData)
        ? garbageData.reduce((sum, item) => {
            const weight = item?.net_weight_kilo_new ?? item?.net_weight_kilo_garbage ?? item?.net_weight_kilo;
            const num = Number(weight) || 0;
            return sum + num;
          }, 0)
        : 0;
      return {
        totalGarbageQuantity: unitTotals.map((u) => ({ unit: u?.unit, total_unit: Number(u?.total_unit) || 0 })),
        totalNetWeight,
      };
    } else {
      const resp = ciGarbageNormal?.data?.status?.data;
      const unitTotalsServer = resp?.unit_array_value_garbage || resp?.unit_array_value_garbage_con || [];
      const dataArr = resp?.data || [];
      const totalNetWeight = Array.isArray(dataArr)
        ? dataArr.reduce((sum, item) => {
            const weight = item?.net_weight_kilo_new ?? item?.net_weight_kilo_garbage ?? item?.net_weight_kilo;
            const num = Number(weight) || 0;
            return sum + num;
          }, 0)
        : 0;
      return {
        totalGarbageQuantity: unitTotalsServer.map((u) => ({ unit: u?.unit, total_unit: Number(u?.total_unit) || 0 })),
        totalNetWeight,
      };
    }
  };

  const productsTotals = getProductsTotals();
  const suppliesTotals = getSuppliesTotals();
  const otherCostsTotals = getOtherCostsTotals();
  const garbageTotals = getGarbageTotals();

  // Estados de loading según el modo
  const isLoadingProducts = listMode ? isLoadingCiProducts : isLoadingCiProductsNormal;
  const isLoadingSupplies = listMode ? isLoadingCiSupplies : isLoadingCiSuppliesNormal;
  const isLoadingOtherCosts = listMode ? isLoadingCiOtherCost : isLoadingCiOtherCostNormal;
  const isLoadingGarbage = listMode ? isLoadingCiGarbage : isLoadingCiGarbageNormal;

  // Hooks de búsqueda en servidor para cada tab
  const {
    filteredData: filteredProducts,
    handleSearch: handleSearchProducts,
    clearSearch: clearSearchProducts,
    hasSearch: hasSearchProducts,
    isLoading: isLoadingSearchProducts
  } = useServerItemSearch(
    idCorrected ? environment.GET_PRODUCTS_CI_CORRECTED : environment.GET_PRODUCTS_CI,
    idCorrected ? idCorrected : id,
    queryEnv?.PRODUCTS_CI,
    orderBy,
    !!(idCorrected || id)
  );

  const {
    filteredData: filteredSupplies,
    handleSearch: handleSearchSupplies,
    clearSearch: clearSearchSupplies,
    hasSearch: hasSearchSupplies,
    isLoading: isLoadingSearchSupplies
  } = useServerItemSearch(
    idCorrected ? environment.GET_SUPPLYS_CI_CORRECTED : environment.GET_SUPPLYS_CI,
    `${idCorrected ? idCorrected : id}${supplyFilter ? `/${supplyFilter}` : ""}`,
    queryEnv?.SUPPLIES_CI,
    orderBy,
    !!(idCorrected || id)
  );

  const {
    filteredData: filteredOtherCosts,
    handleSearch: handleSearchOtherCosts,
    clearSearch: clearSearchOtherCosts,
    hasSearch: hasSearchOtherCosts,
    isLoading: isLoadingSearchOtherCosts
  } = useServerItemSearch(
    idCorrected ? environment.GET_OTHER_COST_CI_CORRECTED : environment.GET_OTHER_COST_CI,
    idCorrected ? idCorrected : id,
    queryEnv?.OTHER_COST_CI,
    orderBy,
    !!(idCorrected || id)
  );

  const {
    filteredData: filteredGarbage,
    handleSearch: handleSearchGarbage,
    clearSearch: clearSearchGarbage,
    hasSearch: hasSearchGarbage,
    isLoading: isLoadingSearchGarbage
  } = useServerItemSearch(
    idCorrected ? environment.GET_GARBAGES_CI_CORRECTED : environment.GET_GARBAGES_CI,
    idCorrected ? idCorrected : id,
    queryEnv?.GARBAGE_CI,
    orderBy,
    !!(idCorrected || id)
  );

  // Resetear páginas cuando cambia orderBy o supplyFilter (solo en modo normal)
  useEffect(() => {
    if (!listMode) {
      setCiProductsPage(1);
      setCiSuppliesPage(1);
      setCiOtherCostPage(1);
      setCiGarbagePage(1);
    }
  }, [orderBy?.value, supplyFilter, listMode]);

  return (
    <>
      {pathname !== "/ShowIntegrationBox" &&
        pathname !== "/CheckIntegrationBox" &&
        pathname !== "/IntegrationCertificateReview" && (
          <ButtonsTable positionView={positionView} />
        )}

      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        placeContent={"flex-end"}
      >
        <InputSelect
          data={[
            { value: "ASC", label: "Ascendente" },
            { value: "DESC", label: "Descendente" },
          ]}
          value={orderBy}
          name="order_by"
          set={(e) => {
            setOrderBy(e);
          }}
          placeholder="Ordenar por"
          inputAttrs={{
            color: "#5f5f",
          }}
          size={20}
          isClearable={false}
        />
      </Box>

      {/* Producto */}
      <Box
        className="tabs-container-cdi-wide"
        style={{
          width: "85vw",
          maxWidth: "85vw",
          margin: "0 auto",
          padding: 0,
          position: "relative",
          left: "55%",
          transform: "translateX(-55%)"
        }}
      >
        <TabsCreateOrder head={tabsCI} change={handleCambio}>
        <TabPanel>
          <SearchByItem
            onSearch={handleSearchProducts}
            placeholder="Buscar productos por número de item (ej: 2)..."
            isLoading={isLoadingSearchProducts}
            clearSearch={clearSearchProducts}
          />
          {listMode ? (
            <div
              id="products-scroll-container"
              ref={productsScrollRef}
              style={{
                height: "70vh",
                maxHeight: "70vh",
                overflowY: "scroll",
                overflowX: "auto",
                width: "100%",
                minWidth: "100%",
                position: "relative",
                WebkitOverflowScrolling: "touch",
                overscrollBehavior: "contain",
              }}
            >
              <InfiniteScroll
                dataLength={hasSearchProducts ? filteredProducts.length : productsData.length}
                next={fetchNextProductsPage}
                hasMore={hasSearchProducts ? false : (hasNextProductsPage === true && !isFetchingNextProductsPage)}
                loader={
                  isFetchingNextProductsPage && (
                    <Box display="flex" justifyContent="center" p={4}>
                      <SpinnerComponent />
                    </Box>
                  )
                }
                scrollableTarget="products-scroll-container"
                endMessage={
                  <Box textAlign="center" p={4} color="gray.500">
                    No hay más productos para cargar
                  </Box>
                }
                scrollThreshold={0.8}
              >
                <TableOrder
                  thead={
                    pathname === "/ShowIntegrationBox"
                      ? theadElaboratedNotEdit
                      : theadElaborated
                  }
                  data={hasSearchProducts ? filteredProducts : productsData}
                  setData={setCurrentPage2}
                  loading={hasSearchProducts ? isLoadingSearchProducts : (isLoadingCiProducts && productsData.length === 0)}
                  tbodyData={TbodyElaborateProduct}
                  subTotals={
                    productsTotals.total_product_net_weight !== undefined
                      ? [
                          productsTotals.total_product_net_weight,
                          productsTotals.total_product_fob,
                          "",
                          "",
                        ]
                      : []
                  }
                  titleTotal="Total"
                  td={[0, 1, 2, 3, 4, 5, 6]}
                  tUnid={productsTotals.totalProdQuantity}
                  tbodyUnd={TbodyUndCertificated}
                />
              </InfiniteScroll>
            </div>
          ) : (
            <>
              <TableOrder
                thead={
                  pathname === "/ShowIntegrationBox"
                    ? theadElaboratedNotEdit
                    : theadElaborated
                }
                data={hasSearchProducts ? filteredProducts : productsData}
                setData={setCurrentPage2}
                loading={hasSearchProducts ? isLoadingSearchProducts : isLoadingProducts}
                tbodyData={TbodyElaborateProduct}
                subTotals={
                  productsTotals.total_product_net_weight !== undefined
                    ? [
                        productsTotals.total_product_net_weight,
                        productsTotals.total_product_fob,
                        "",
                        "",
                      ]
                    : []
                }
                titleTotal="Total"
                td={[0, 1, 2, 3, 4, 5, 6]}
                tUnid={productsTotals.totalProdQuantity}
                tbodyUnd={TbodyUndCertificated}
                currentPage={hasSearchProducts ? 1 : ciProductsPage}
                itemsPerPage={hasSearchProducts ? filteredProducts.length : (ciProductsNormal?.data?.status?.code === 200 ? ciProductsNormal?.data?.status?.data?.per_page || 5 : 5)}
              />
              {!hasSearchProducts && (
                <Pagination
                  page={ciProductsPage}
                  setPage={setCiProductsPage}
                  maxPage={
                    ciProductsNormal?.data?.status?.code === 200 &&
                    (ciProductsNormal?.data?.status?.data?.last_page || 1)
                  }
                  loading={isLoadingProducts}
                />
              )}
            </>
          )}
        </TabPanel>

        <TabPanel>
          {/* Materia prima (CAMBIAR) */}
          {/* PREGUNTAR A KETY */}
          {(foundMutation?.status || foundMutation?.newData?.status) ===
            "PRESENTADO" && (
            <TotalsCalculated
              data={
                suppliesTotals.total_supply_net_weight_new !== undefined
                  ? {
                      total_supply_net_weight_new: suppliesTotals.total_supply_net_weight_new,
                      total_supply_fob_new: suppliesTotals.total_supply_fob_new,
                      totalSupplies: suppliesTotals.totalSupplies,
                    }
                  : null
              }
              supplyFilter={supplyFilter}
              setSupplyFilter={setSupplyFilter}
            />
          )}

          <div>
            <SearchByItem
              onSearch={handleSearchSupplies}
              placeholder="Buscar insumos por número de item (ej: 2)..."
              isLoading={isLoadingSearchSupplies}
              clearSearch={clearSearchSupplies}
            />
            {listMode ? (
              <div
                id="supplies-scroll-container"
                ref={suppliesScrollRef}
                style={{
                  height: "70vh",
                  overflowY: "auto",
                  overflowX: "auto",
                  width: "100%",
                  minWidth: "100%",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <InfiniteScroll
                  dataLength={hasSearchSupplies ? filteredSupplies.length : suppliesData.length}
                  next={fetchNextSuppliesPage}
                  hasMore={hasSearchSupplies ? false : !!hasNextSuppliesPage}
                  loader={
                    <Box display="flex" justifyContent="center" p={4}>
                      <SpinnerComponent />
                    </Box>
                  }
                  scrollableTarget="supplies-scroll-container"
                  endMessage={
                    <Box textAlign="center" p={4} color="gray.500">
                      No hay más insumos para cargar
                    </Box>
                  }
                >
                  <TableOrder
                    thead={THead[pathname]?.() || THead.Default?.()}
                    data={hasSearchSupplies ? filteredSupplies : suppliesData}
                    setData={setCurrentPage2}
                    loading={hasSearchSupplies ? isLoadingSearchSupplies : isLoadingSupplies}
                    tbodyData={TbodyRawMaterial}
                    subTotals={
                      suppliesTotals.total_supply_net_weight_new !== undefined
                        ? [
                            suppliesTotals.total_supply_net_weight_new,
                            suppliesTotals.total_supply_fob_new,
                            "",
                            "",
                            "",
                            "",
                            "",
                          ]
                        : []
                    }
                    titleTotal="Total"
                    td={
                      pathname === "/ShowIntegrationBox"
                        ? arrayMatteriaNotEdit
                        : pathname === "/CorrectedCertificate"
                        ? arrayMatteriaNotEditCorrected
                        : arrayMatteriaEdit
                    }
                    tUnid={suppliesTotals.totalSupplies}
                    tbodyUnd={TbodySupplyUnit}
                  />
                </InfiniteScroll>
              </div>
            ) : (
              <>
                <TableOrder
                  thead={THead[pathname]?.() || THead.Default?.()}
                  data={hasSearchSupplies ? filteredSupplies : suppliesData}
                  setData={setCurrentPage2}
                  loading={hasSearchSupplies ? isLoadingSearchSupplies : isLoadingSupplies}
                  tbodyData={TbodyRawMaterial}
                  subTotals={
                    suppliesTotals.total_supply_net_weight_new !== undefined
                      ? [
                          suppliesTotals.total_supply_net_weight_new,
                          suppliesTotals.total_supply_fob_new,
                          "",
                          "",
                          "",
                          "",
                          "",
                        ]
                      : []
                  }
                  titleTotal="Total"
                  td={
                    pathname === "/ShowIntegrationBox"
                      ? arrayMatteriaNotEdit
                      : pathname === "/CorrectedCertificate"
                      ? arrayMatteriaNotEditCorrected
                      : arrayMatteriaEdit
                  }
                  tUnid={suppliesTotals.totalSupplies}
                  tbodyUnd={TbodySupplyUnit}
                  currentPage={hasSearchSupplies ? 1 : ciSuppliesPage}
                  itemsPerPage={hasSearchSupplies ? filteredSupplies.length : (ciSuppliesNormal?.data?.status?.code === 200 ? ciSuppliesNormal?.data?.status?.data?.per_page || 5 : 5)}
                />
                {!hasSearchSupplies && (
                  <Pagination
                    page={ciSuppliesPage}
                    setPage={setCiSuppliesPage}
                    maxPage={
                      ciSuppliesNormal?.data?.status?.code === 200 &&
                      (ciSuppliesNormal?.data?.status?.data?.last_page || 1)
                    }
                    loading={isLoadingSupplies}
                  />
                )}
              </>
            )}
            {!hasSearchSupplies && (
              <div className="boton">
                <CustomButton isActive={isOpen} onClick={handleOpenDatosInsumo}>
                  Datos insumo
                </CustomButton>
              </div>
            )}
          </div>
        </TabPanel>
        {/* Otros costos */}
        <TabPanel>
          <SearchByItem
            onSearch={handleSearchOtherCosts}
            placeholder="Buscar otros costos por número de item (ej: 2)..."
            isLoading={isLoadingSearchOtherCosts}
            clearSearch={clearSearchOtherCosts}
          />
          {listMode ? (
            <div
              id="other-costs-scroll-container"
              ref={otherCostsScrollRef}
              style={{
                height: "70vh",
                overflowY: "auto",
                overflowX: "auto",
                width: "100%",
                minWidth: "100%",
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <InfiniteScroll
                dataLength={hasSearchOtherCosts ? filteredOtherCosts.length : otherCostsData.length}
                next={fetchNextOtherCostsPage}
                hasMore={hasSearchOtherCosts ? false : !!hasNextOtherCostsPage}
                loader={
                  <Box display="flex" justifyContent="center" p={4}>
                    <SpinnerComponent />
                  </Box>
                }
                scrollableTarget="other-costs-scroll-container"
                endMessage={
                  <Box textAlign="center" p={4} color="gray.500">
                    No hay más otros costos para cargar
                  </Box>
                }
              >
                <TableOrder
                  thead={
                    pathname === "/ShowIntegrationBox" ? theadOtherEdit : theadOther
                  }
                  data={hasSearchOtherCosts ? filteredOtherCosts : otherCostsData}
                  setData={setCurrentPage2}
                  loading={hasSearchOtherCosts ? isLoadingSearchOtherCosts : isLoadingOtherCosts}
                  tbodyData={TbodyOtherCosts}
                  subTotals={
                    otherCostsTotals.totalOtherNetWeight !== undefined
                      ? ["", otherCostsTotals.totalOtherNetWeight, otherCostsTotals.totalOtherFobValue, otherCostsTotals.totalValueUnit, ""]
                      : []
                  }
                  titleTotal="Total"
                />
              </InfiniteScroll>
            </div>
          ) : (
            <>
              <TableOrder
                thead={
                  pathname === "/ShowIntegrationBox" ? theadOtherEdit : theadOther
                }
                data={hasSearchOtherCosts ? filteredOtherCosts : otherCostsData}
                setData={setCurrentPage2}
                loading={hasSearchOtherCosts ? isLoadingSearchOtherCosts : isLoadingOtherCosts}
                tbodyData={TbodyOtherCosts}
                subTotals={
                  otherCostsTotals.totalOtherNetWeight !== undefined
                    ? ["", otherCostsTotals.totalOtherNetWeight, otherCostsTotals.totalOtherFobValue, otherCostsTotals.totalValueUnit, ""]
                    : []
                }
                titleTotal="Total"
                currentPage={hasSearchOtherCosts ? 1 : ciOtherCostPage}
                itemsPerPage={hasSearchOtherCosts ? filteredOtherCosts.length : (ciOtherCostNormal?.data?.status?.code === 200 ? ciOtherCostNormal?.data?.status?.data?.per_page || 5 : 5)}
              />
              {!hasSearchOtherCosts && (
                <Pagination
                  page={ciOtherCostPage}
                  setPage={setCiOtherCostPage}
                  maxPage={
                    ciOtherCostNormal?.data?.status?.code === 200 &&
                    (ciOtherCostNormal?.data?.status?.data?.last_page || 1)
                  }
                  loading={isLoadingOtherCosts}
                />
              )}
            </>
          )}
        </TabPanel>
        {/* Desperdicios */}
        <TabPanel>
          <SearchByItem
            onSearch={handleSearchGarbage}
            placeholder="Buscar desperdicios por número de item (ej: 2)..."
            isLoading={isLoadingSearchGarbage}
            clearSearch={clearSearchGarbage}
          />
          {listMode ? (
            <div
              id="garbage-scroll-container"
              ref={garbageScrollRef}
              style={{
                height: "70vh",
                overflowY: "auto",
                overflowX: "auto",
                width: "100%",
                minWidth: "100%",
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <InfiniteScroll
                dataLength={hasSearchGarbage ? filteredGarbage.length : garbageData.length}
                next={fetchNextGarbagePage}
                hasMore={hasSearchGarbage ? false : !!hasNextGarbagePage}
                loader={
                  <Box display="flex" justifyContent="center" p={4}>
                    <SpinnerComponent />
                  </Box>
                }
                scrollableTarget="garbage-scroll-container"
                endMessage={
                  <Box textAlign="center" p={4} color="gray.500">
                    No hay más desperdicios para cargar
                  </Box>
                }
              >
                <TableOrder
                  thead={theadDesperdicios}
                  data={hasSearchGarbage ? filteredGarbage : garbageData}
                  loading={hasSearchGarbage ? isLoadingSearchGarbage : isLoadingGarbage}
                  tbodyData={TBodyGarbage}
                  subTotals={[garbageTotals?.totalNetWeight || 0]}
                  titleTotal="Total"
                  td={[0, 1, 2]}
                  tUnid={garbageTotals?.totalGarbageQuantity}
                  tbodyUnd={TbodyGarbageUnit}
                />
              </InfiniteScroll>
            </div>
          ) : (
            <>
              <TableOrder
                thead={theadDesperdicios}
                data={hasSearchGarbage ? filteredGarbage : garbageData}
                loading={hasSearchGarbage ? isLoadingSearchGarbage : isLoadingGarbage}
                tbodyData={TBodyGarbage}
                subTotals={[garbageTotals?.totalNetWeight || 0]}
                titleTotal="Total"
                td={[0, 1, 2]}
                tUnid={garbageTotals?.totalGarbageQuantity}
                tbodyUnd={TbodyGarbageUnit}
                currentPage={hasSearchGarbage ? 1 : ciGarbagePage}
                itemsPerPage={hasSearchGarbage ? filteredGarbage.length : (ciGarbageNormal?.data?.status?.code === 200 ? ciGarbageNormal?.data?.status?.data?.per_page || 5 : 5)}
              />
              {!hasSearchGarbage && (
                <Pagination
                  page={ciGarbagePage}
                  setPage={setCiGarbagePage}
                  maxPage={
                    ciGarbageNormal?.data?.status?.code === 200 &&
                    (ciGarbageNormal?.data?.status?.data?.last_page || 1)
                  }
                  loading={isLoadingGarbage}
                />
              )}
            </>
          )}
        </TabPanel>
        {/* CAMBIAR */}
        {cambio === 1 && foundMutation?.status === "PRESENTADO" && (
          <BoxCalc
            Data={currentPage2?.supplies ? currentPage2?.supplies : []}
          />
        )}
      </TabsCreateOrder>
      </Box>

      {/* Botón flotante para activar/desactivar scroll infinito */}
      <Fab
        mainButtonStyles={{
          backgroundColor: '#3498db',
          width: '40px',
          height: '40px'
        }}
        event='click'
        icon={<RiListSettingsLine />}
        // alwaysShowTitle={true}
        text={listMode ? 'Scroll infinito' : 'Modo normal'}
        onClick={switchLoadingItem}
      />
    </>
  );
};

export default OptionPanelTabs;
